import { teamCanSeeEntity } from '../../domain/entity/entityVision.js';

/**
 * Click/attack targeting uses shared team vision (allied minions + champs).
 */
export function clickTargetVisible(controller, target) {
  const champ = controller?.championEntity;
  if (!champ) return true;
  const units = typeof controller.getDamageableTargetsCallback === 'function'
    ? controller.getDamageableTargetsCallback()
    : [];
  const wards = typeof controller.getActiveWardsCallback === 'function'
    ? controller.getActiveWardsCallback()
    : [];
  return teamCanSeeEntity(
    champ.team,
    target,
    [champ, ...units],
    controller.bushZones,
    wards,
    controller.wallBoxes
  );
}
